import React, { useEffect, useContext, useState, useRef } from 'react'

import {
  Box,
  Switch,
} from '@mui/material';

import addForAdmin from '../../../../../images/addForAdmin.svg'

import SuperAdminContext from "../../../../../contexts/SuperAdminContext"
import { quizVariant, QUIZ_QCM, QUIZ_VRAI_FAUX } from "../../../../../utils/quizVariant"

const QuizzHelper = ({ format }) => {

  const superAdminContext = useContext(SuperAdminContext)

  /* Le bloc est actif des qu'une des deux colonnes n'est pas NULL. La chaine
     vide compte comme « active mais pas encore ecrite » : c'est ce qui permet
     d'allumer l'interrupteur avant d'avoir tape le texte. */
  const feedbackActif = (format?.success !== null && format?.success !== undefined)
                     || (format?.fail !== null && format?.fail !== undefined)

  const handleResponseChange = (key, value, i) => {
    var data = format?.responses
    data[i][key] = value

    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const removeResponse = (i) => {
    var data = format?.responses
    data.splice(i, 1)
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const addResponse = (e) => {
    var data = format?.responses
    data.push({ points : 0, reponse: 'Texte à modifier', isValid: format?.noValidAnswer ? null : false })
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const moveCat = (i, nMove) => {
    var data = format?.responses
    const tmp = data.splice(i, 1)
    data.splice(i + nMove, 0, tmp[0])
    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }

  const handleCheckEditor = (iRep) => {
    if (format?.noValidAnswer) return null

    var data = format?.responses
    if (!format?.multi) {
      for (var i = 0; i < data.length; i++) {
        data[i].isValid = false
      }
    }

    data[iRep].isValid = !data[iRep].isValid
    for (var i = 0; i < data.length; i++) {
      data[i].points = data[i].isValid ? 1 : 0
    }

    superAdminContext?.onSequenceChange(
      'responses',
      data,
      superAdminContext?.adminPlayerIndexes
    )
  }


  return (
    <>
      <Box sx={{marginBottom:"2px", fontWeight:"bold"}}>Catégorie</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
        <Box sx={{flex:1}}>
          <input
            value={format?.categorie || 'master'}
            style={{width:"100%"}}
            onChange={(e) => {
              superAdminContext?.onSequenceChange(
                'categorie',
                e.target.value,
                superAdminContext?.adminPlayerIndexes
              )
            }}
          />
        </Box>
      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Question</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px",}}>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={format?.multi?true:false}
            onChange={(e) => {
              superAdminContext?.onSequenceChange(
                'multi',
                e.target.checked,
                superAdminContext?.adminPlayerIndexes
              )
            }}
            size="small"
            color="warning"
          />
          Question à choix multiple
        </Box>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={format?.noValidAnswer?true:false}
            onChange={(e) => {
              superAdminContext?.onSequenceChange(
                'noValidAnswer',
                e.target.checked,
                superAdminContext?.adminPlayerIndexes
              )
            }}
            size="small"
            color="warning"
          />
          Question sans bonne réponse
        </Box>
      </Box>
      {/* Audit de taxonomie 18/09/2026 : la variante d'AFFICHAGE est explicite et
          vit dans `answers.quizVariant` (aucune colonne nouvelle).
          Elle est rangee A PART des deux reglages ci-dessus, qui decident du
          COMPORTEMENT et du score : celui-ci ne change que la mise en page.
          C'est aussi le SEUL moyen de marquer un quiz existant — on ne reclassera
          jamais l'historique automatiquement. */}
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Affichage</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px",}}>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={quizVariant(format) === QUIZ_VRAI_FAUX}
            /* Le layout deux boutons cote a cote n'a de sens qu'a DEUX reponses :
               a 3+ ils deviennent illisibles sur un petit ecran. On bloque donc
               ici, dans l'editeur — surtout pas par un repli au rendu, qui
               reintroduirait un comptage de reponses dans le lecteur. */
            disabled={format?.responses?.length !== 2}
            onChange={(e) => {
              /* ⚠️ On FUSIONNE `answers` : il porte deja good/bad/text, et
                 l'ecraser — comme le fait le bouton Textarea d'InputTexte —
                 perdrait les textes de feedback. Le garde `typeof` protege d'une
                 valeur non-objet (colonne doublement encodee), dont le spread
                 produirait une bouillie de caracteres. */
              const base = (format?.answers && typeof format.answers === "object") ? format.answers : {}
              superAdminContext?.onSequenceChange(
                'answers',
                { ...base, quizVariant: e.target.checked ? QUIZ_VRAI_FAUX : QUIZ_QCM },
                superAdminContext?.adminPlayerIndexes
              )
            }}
            size="small"
            color="warning"
          />
          Vrai / Faux (deux choix côte à côte)
        </Box>
        {format?.responses?.length !== 2 &&
          <Box sx={{fontSize:"11px", opacity:0.75, marginTop:"3px"}}>
            Disponible uniquement avec exactement 2 réponses (cette question en a {format?.responses?.length ?? 0}).
          </Box>
        }
      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Réponses</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px",}}>

        <Box sx={{display:"flex", alignItems:"center", justifyContent:"space-between", borderBottom:"1px solid #BABABA"}}>
          <Box sx={{display:"flex"}}>
            <p style={{marginBottom:'5px', fontSize:'10px', width:"40px"}}>Pts</p>
            <p style={{marginBottom:'5px', fontSize:'10px', width:"30px"}}>Valid</p>
            <p style={{marginBottom:'5px', fontSize:'10px'}}>Texte</p>
          </Box>
        </Box>
        {format?.responses?.map((item, i)=>(
          <Box
            sx={{
              display:"flex",
              alignItems:"center",
              justifyContent:"space-between",
              borderBottom:"1px solid #BABABA",
              "&:hover" : {
                ".svgDelete" : {
                  opacity: "1 !important"
                }
              }
            }}
            id={'answer' + i}
            key={'response-' + i}
          >
            <Box sx={{
              paddingTop:"2px",
              paddingBottom:"2px",
              display:"flex"
            }}>
              <input
                value={item.points ?? 0}
                style={{width:"35px", fontSize:"12px"}}
                type="number"
                onChange={(e) => {
                  handleResponseChange('points', e.target.value ?  parseInt(e.target.value) : 0, i)
                }}
              />
              <Box sx={{
                width:"25px",
                marginLeft:"5px",
                paddingLeft:"3px"
              }}>
                <Box
                  onClick={() => {handleCheckEditor(i)}}
                  sx={{
                    width:"18px",
                    height:"18px",
                    border:"1px solid black",
                    cursor:"pointer",
                    borderRadius:format?.multi?"3px":"50%",
                    background:format?.noValidAnswer ? "white" : item?.isValid ? "green" : "red",
                  }}
               />
              </Box>
              <input
                value={item.reponse}
                style={{marginLeft:"5px", width:"160px", fontSize:"12px"}}
                onChange={(e) => {
                  handleResponseChange('reponse', e.target.value, i)
                }}
              />

            </Box>
            <Box sx={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
              <svg className="svgDelete" style={{fill:"silver", opacity:0, cursor:"pointer"}} onClick={()=> { removeResponse(i) }} width="20" height="20" version="1.1" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" >
                <path d="m491.51 177.63h-283.02c-4.8047-0.03125-9.3945 1.9961-12.605 5.5742-3.2148 3.5742-4.7383 8.3555-4.1953 13.129l28 244.5c2.0234 17.77 10.516 34.176 23.859 46.086 13.348 11.906 30.609 18.488 48.492 18.48h120.57c18.113 0 35.574-6.7539 48.973-18.945 13.402-12.188 21.777-28.934 23.488-46.965l23.188-243.49c0.44141-4.7188-1.1328-9.4062-4.332-12.906s-7.7305-5.4844-12.469-5.4609z"/>
                <path d="m424.48 93.801c0-10.398-4.1289-20.367-11.48-27.719-7.3516-7.3516-17.324-11.48-27.719-11.48h-70.562c-10.395 0-20.367 4.1289-27.719 11.48-7.3516 7.3516-11.48 17.32-11.48 27.719v14.785h-124.77v33.602l398.49-0.003906v-33.602l-124.77 0.003907zm-33.602 14.785h-81.758v-14.785c0-3.0938 2.5078-5.6016 5.5977-5.6016h70.562c1.4844 0 2.9102 0.58984 3.957 1.6406 1.0508 1.0508 1.6406 2.4766 1.6406 3.9609z"/>
              </svg>
              {i !== 0 &&
                <Box onClick={()=> { moveCat(i,-1) }} sx={{color:"#7C7C7C", opacity:"0.3", fontSize:"12px", cursor:"pointer", marginLeft:"1px"}}>▲</Box>
              }
              {(format?.responses?.length > 1 && i !== format?.responses?.length - 1) &&
                <Box onClick={()=> { moveCat(i,+1) }} sx={{color:"#7C7C7C", opacity:"0.3", fontSize:"12px", cursor:"pointer", marginLeft:"2px"}}>▼</Box>
              }
            </Box>
          </Box>
        ))}
        {quizVariant(format) === QUIZ_VRAI_FAUX ? (
          /* Le layout Vrai/Faux pose les choix COTE A COTE : un troisieme bouton
             les rendrait illisibles (sur 390 px, trois boutons ne tiennent pas).
             On retire donc l'ajout tant que cette variante est active, plutot que
             de laisser fabriquer un ecran casse. */
          <Box sx={{marginTop:"4px", fontSize:"12px", opacity:0.75}}>
            Affichage Vrai / Faux&nbsp;: exactement 2 réponses. Repassez en QCM pour en ajouter.
          </Box>
        ) : (
          <Box sx={{marginTop:"4px"}} onClick={() => { addResponse() }}>
            <Box style={{display:'flex', alignItems:'center', cursor:'pointer'}}>
              <img src={addForAdmin} style={{width:"12px"}} />
              <span style={{fontSize:"12px", marginLeft:'5px'}}>Ajoutez une réponse</span>
            </Box>
          </Box>
        )}

      </Box>
      {/* ⛔ POINT 1.1 DE LA FICHE V2 (Nawal, 07/09) — LE FEEDBACK DU QUIZZ.
          Le rendu existait depuis toujours cote apprenant, et les colonnes
          `success` et `fail` existent en base : ce sont bien DEUX textes
          distincts par question. Mais il n'y avait aucun endroit pour les
          saisir. Nawal ne pouvait donc pas ecrire ces textes, et devait
          demander une ecriture directe en base a chaque fois.
          C'est ici que ca doit vivre : tout ce qui definit le comportement
          d'une question de quizz est deja dans ce panneau.
          L'interrupteur n'a pas de colonne dediee, et il n'en faut pas : le
          lecteur n'affiche le bloc que si le texte est rempli. Activer pose
          donc deux chaines vides, desactiver remet NULL. Un quizz d'avant,
          dont les deux colonnes sont NULL, arrive naturellement eteint. */}
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Réponse expliquée</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={feedbackActif}
            disabled={format?.noValidAnswer ? true : false}
            onChange={(e) => {
              const v = e.target.checked ? "" : null
              superAdminContext?.onSequenceChange('success', v, superAdminContext?.adminPlayerIndexes)
              superAdminContext?.onSequenceChange('fail', v, superAdminContext?.adminPlayerIndexes)
            }}
            size="small"
            color="warning"
          />
          Affichage de la réponse
        </Box>
        {format?.noValidAnswer === true &&
          <Box sx={{fontSize:"11px", color:"#7C7C7C", marginTop:"2px"}}>
            Indisponible&nbsp;: une question sans bonne réponse n'a rien à expliquer.
          </Box>
        }
        {/* ⛔ Les deux champs sont TOUJOURS visibles, meme interrupteur eteint.
            Avant, ils n'apparaissaient qu'une fois l'interrupteur bascule :
            Nawal voyait un bouton et aucun endroit ou ecrire, et nous a dit
            « je n'avais pas l'espace dans l'admin pour le remplir ». Un champ
            qu'on ne voit pas n'existe pas.
            Eteints, ils sont grises et en lecture seule : la place se voit,
            l'interrupteur garde son role. */}
        {format?.noValidAnswer !== true &&
          <>
            {!feedbackActif &&
              <Box sx={{marginTop:"6px", fontSize:"11px", color:"#7C7C7C", fontStyle:"italic"}}>
                Activez l'affichage ci-dessus pour écrire ces deux textes.
              </Box>
            }
            <Box sx={{marginTop:"6px", fontSize:"11px", opacity: feedbackActif ? 1 : 0.5}}>Quand la réponse est bonne</Box>
            <textarea
              value={format?.success ?? ""}
              disabled={!feedbackActif}
              placeholder="Pourquoi cette réponse est la bonne, et ce qu'elle apprend."
              rows={4}
              style={{width:"100%", fontSize:"12px", boxSizing:"border-box", fontFamily:"inherit", resize:"vertical"}}
              onChange={(e) => {
                superAdminContext?.onSequenceChange('success', e.target.value, superAdminContext?.adminPlayerIndexes)
              }}
            />
            <Box sx={{marginTop:"8px", fontSize:"11px", opacity: feedbackActif ? 1 : 0.5}}>Quand la réponse est mauvaise</Box>
            <textarea
              value={format?.fail ?? ""}
              disabled={!feedbackActif}
              placeholder="Ce que l'apprenant a manqué, et le geste à retenir."
              rows={4}
              style={{width:"100%", fontSize:"12px", boxSizing:"border-box", fontFamily:"inherit", resize:"vertical"}}
              onChange={(e) => {
                superAdminContext?.onSequenceChange('fail', e.target.value, superAdminContext?.adminPlayerIndexes)
              }}
            />
            {format?.multi === true &&
              <Box sx={{fontSize:"11px", color:"#7C7C7C", marginTop:"4px"}}>
                Question à choix multiple&nbsp;: une réponse incomplète est comptée
                juste au prorata des points, mais lit le texte « mauvaise
                réponse ». Écrivez-le pour qu'il vaille aussi dans ce cas.
              </Box>
            }
          </>
        }
      </Box>
      <Box sx={{marginTop:"10px", marginBottom:"2px", fontWeight:"bold"}}>Image</Box>
      <Box sx={{border:"1px solid #2929292f", padding:"5px"}}>
        <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
          <Switch
            sx={{marginLeft:"-5px"}}
            checked={format?.image?true:false}
            onChange={(e) => {
              if (e.target.checked) {
                superAdminContext?.onSequenceChange(
                  'image',
                  { link: 'https://video.thelab.risinguparis.com/brain.svg', type: 'contain' },
                  superAdminContext?.adminPlayerIndexes
                )
              } else {
                superAdminContext?.onSequenceChange(
                  'image',
                  null,
                  superAdminContext?.adminPlayerIndexes
                )
              }
            }}
            size="small"
            color="warning"
          />
          Afficher une image
        </Box>
        {format?.image &&
          <>
            {/* ⛔ 01/10/2026 — L'INTERRUPTEUR « ELARGIR L'IMAGE » EST RETIRE.
                Decision d'Hicham : « Image entiere toujours », puis « oui
                retire, on verra avec Nawal ce qu'elle prefere ».
                Il choisissait entre `cover` (remplir, donc rogner) et
                `contain` (tout voir). L'image est desormais TOUJOURS
                entiere : il ne decidait plus de rien. Un interrupteur qui ne
                fait rien est pire qu'un interrupteur absent — Nawal l'aurait
                actionne en cherchant un effet.
                ⚠️ LA DONNEE N'EST PAS TOUCHEE : `image.type` reste en base
                sur les ecrans existants, simplement plus lu pour le
                rognage. Si la decision revient, c'est ce bloc qu'on remet,
                et rien a remigrer. */}
            <Box sx={{display:"flex", gap:"5px", alignItems:"center"}}>
              <Box>
                Url&nbsp;:
              </Box>
              <Box sx={{flex:1}}>
                <input
                  value={format?.image?.link}
                  style={{width:"100%"}}
                  onChange={(e) => {
                    superAdminContext?.onSequenceChange(
                      'image',
                      { link: e.target.value, type: format?.image?.type },
                      superAdminContext?.adminPlayerIndexes
                    )
                  }}
                />
              </Box>
            </Box>
          </>
        }
      </Box>
    </>
  )
};

export default QuizzHelper;
